import { IStyle } from 'Styles';
import RMTable from 'components/customComponents/Controls/RMTable';
import React, { useState, useEffect, useRef } from 'react';
import { GroupQuotaTableColumns, ImagerTableColumns } from './constants';
import { onUpdateImagerGroups, useImagerQuota } from 'redux/hooks/imagerQuota';
import HeaderBar from '../../CrystalContainer/HeaderBar';

const excludedGroups = ['Administrators', 'AllRockMakerUsers'];
const defaultQuotaValue = 'unlimited';

const ImagerQuota = () => {
  const imagerQuotaList = useImagerQuota();
  const updateImagerGroups = onUpdateImagerGroups();
  const [selectedQuotaId, setSelectedQuotaId] = useState(0);
  const [selectedGroupId, setSelectedGroupId] = useState(0);
  const [editId, setEditId] = useState(-1);
  const [localPlateQuotas, setLocalPlateQuotas] = useState<Record<string, string>>({});
  const prevQuotaIdRef = useRef(selectedQuotaId[0]);

  const selectedImagerQuota = imagerQuotaList[selectedQuotaId];
  useEffect(() => {
    if (prevQuotaIdRef.current === selectedQuotaId[0]) {
      return;
    }
    prevQuotaIdRef.current = selectedQuotaId[0];
    setLocalPlateQuotas({});
  }, [selectedQuotaId]);

  const imagerGroups =
    selectedImagerQuota?.imagerGroups
      ?.filter((grp) => !excludedGroups.includes(grp.groupName))
      .map((group: any, index) => {
        const localValue = localPlateQuotas[group.id];
        const displayValue =
          localValue !== undefined
            ? localValue
            : group.plateQuota < 0
            ? defaultQuotaValue
            : String(group.plateQuota);

        return {
          ...group,
          isDirty: false,
          plateQuota: (
            <input
              id={`imagerquota-imagergroups-${index}-platequota-input`}
              type="text"
              className={`w-full ${
                editId === index
                  ? 'rounded-sm bg-white p-1'
                  : 'table-input-style pointer-events-none'
              }`}
              onChange={(e) => onCellChange(e, group.id)}
              value={displayValue}
            />
          ),
        };
      }) || [];

  const onCellChange = (e, id) => {
    let inputValue = e.target.value;
    if (
      (inputValue.length < defaultQuotaValue.length &&
        defaultQuotaValue.startsWith(inputValue)) ||
      (inputValue.startsWith(defaultQuotaValue) &&
        inputValue.length > defaultQuotaValue.length &&
        defaultQuotaValue.startsWith(inputValue)) ||
      inputValue === ''
    ) {
      inputValue = inputValue.replace(defaultQuotaValue, '');
      const updatedGroups = selectedImagerQuota?.imagerGroups?.map((grp) =>
        grp.id === id ? { ...grp, plateQuota: -1, isDirty: true } : grp,
      );
      updateImagerGroups(selectedImagerQuota.id, updatedGroups);
    } else if (!isNaN(Number(inputValue))) {
      inputValue = inputValue.replace(defaultQuotaValue, '');
      const updatedGroups = selectedImagerQuota?.imagerGroups?.map((grp) =>
        grp.id === id ? { ...grp, plateQuota: Number(inputValue), isDirty: true } : grp,
      );
      updateImagerGroups(selectedImagerQuota.id, updatedGroups);
    }
    setLocalPlateQuotas((prev) => ({ ...prev, [id]: inputValue }));
  };

  const handleOnQuotaRowCLick = (row) => {
    setSelectedQuotaId(row.index);
  };

  const handleOnGroupRowCLick = (row) => {
    setSelectedGroupId(row.index);
    setEditId(-1);
  };

  const handleGroupEdit = () => {
    setEditId(selectedGroupId);
  };

  const handleSetDefaultQuota = () => {
    if (!selectedImagerQuota) {
      return;
    }
    const imagerGroups = { ...selectedImagerQuota }?.imagerGroups?.map((grp) => {
      return {
        ...grp,
        plateQuota: -1,
        isDirty: true,
      };
    });

    setLocalPlateQuotas({});
    updateImagerGroups(selectedImagerQuota.id, imagerGroups);
  };

  return (
    <div id="imagerquota-container" className="w-full h-[91vh] flex flex-row">
      <div id="imagerquota-imagerrobot-wrapper" className="w-full h-[90%] p-2">
        <div id="imagerquota-imagerrobot-title" className="flex align-center mt-2 mb-3">
          <span id="imagerquota-imagerrobot-title-content" className="text-lg font-bold">
            Imager Robot
          </span>
        </div>
        <div
          id="imagerquota-imagerrobot-tables"
          className="mt-1 h-full overflow-auto border border-[#DEE2E6]"
        >
          <RMTable
            columns={ImagerTableColumns}
            data={imagerQuotaList}
            tableClass="w-full"
            mainContainerStyle={styles.tableMainContainerStyle}
            selectedIds={[selectedQuotaId]}
            onRowClicked={handleOnQuotaRowCLick}
          />
        </div>
      </div>
      <div id="imagerquota-groupquota-wrapper" className="w-full h-[90%] p-2">
        <HeaderBar
          title={'Group Quota'}
          onSetDefaultQuota={handleSetDefaultQuota}
          disableSetDefaultQuota={!selectedImagerQuota}
          onEdit={handleGroupEdit}
          enableEditDelete={true}
        />
        <div
          id="imagerquota-groupquota-tables"
          className="mt-1 h-full overflow-auto border border-[#DEE2E6]"
        >
          <RMTable
            columns={GroupQuotaTableColumns}
            data={imagerGroups}
            tableClass="w-full"
            mainContainerStyle={styles.tableMainContainerStyle}
            selectedIds={[selectedGroupId]}
            onRowClicked={handleOnGroupRowCLick}
          />
        </div>
      </div>
    </div>
  );
};

export default ImagerQuota;

const styles: IStyle = {
  tableMainContainerStyle: {
    height: '95%',
    overflow: 'auto',
  },
};
